<script setup lang="ts">
import { switchProps } from 'naive-ui';

const props = defineProps(switchProps);
</script>

<template>
  <!-- Themed n-switch (Switch section in gaia-light.json) — a setting that
       takes effect immediately (column visibility, CSV export options). For a
       switch with a label and hint beside it, use composite/GaiaToggleRow. -->
  <n-switch v-bind="props">
    <template v-if="$slots.checked" #checked><slot name="checked" /></template>
    <template v-if="$slots.unchecked" #unchecked><slot name="unchecked" /></template>
  </n-switch>
</template>
